var map = {
	"./acsi.json": 1500,
	"./de-de.json": 1501,
	"./en-us.json": 655,
	"./id.json": 1502,
	"./ja.json": 1503,
	"./ko.json": 1504,
	"./vi.json": 1505,
	"./whitelists/whitelist_acsi.json": 1506,
	"./whitelists/whitelist_de-de.json": 1507,
	"./whitelists/whitelist_en-us.json": 1508,
	"./whitelists/whitelist_en.json": 1509,
	"./whitelists/whitelist_id.json": 1510,
	"./whitelists/whitelist_ja.json": 1511,
	"./whitelists/whitelist_ko.json": 1512,
	"./whitelists/whitelist_vi.json": 1513,
	"./whitelists/whitelist_zh-cn.json": 1514,
	"./whitelists/whitelist_zh-tw.json": 1515,
	"./zh-cn.json": 1516,
	"./zh-tw.json": 1517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1499;